import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Content,
  IntegrationCard,
  Tags,
  Title,
  Image,
  ImageContainer,
} from './style';
import { IntegrationProps } from '../main/constants';
import { useIntegrationData } from '../main/data';
import { StatusBadge } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';

interface IntegrationData {
  integration: IntegrationProps;
}

export const Integration = ({ integration }: IntegrationData) => {
  const { t } = useTranslation();
  const history = useHistory();
  const data = useIntegrationData();
  const { DISCOVER_BY_FILTERS } = data;

  const { categories, path, imgSrc, name } = integration;
  const getBadge = (category: string, idx: number) => {
    switch (category) {
      case DISCOVER_BY_FILTERS.FREE_TRIAL:
        return (
          <StatusBadge key={idx} variant={'success'} text={t('Free Trial')} />
        );
      case DISCOVER_BY_FILTERS.FEATURED:
        return (
          <StatusBadge key={idx} variant={'primary'} text={t('Featured')} />
        );
      case DISCOVER_BY_FILTERS.NEWEST:
        return <StatusBadge key={idx} variant='success' text={t('New')} />;
      default:
        return <StatusBadge key={idx} variant='neutral' text={t(category)} />;
    }
  };
  return (
    <IntegrationCard
      onClick={() => {
        history.push(path);
      }}
    >
      <ImageContainer>
        <Image src={imgSrc} />
      </ImageContainer>
      <Content>
        <Title>{name}</Title>
      </Content>
      <Tags>{categories.map((category, idx) => getBadge(category, idx))}</Tags>
    </IntegrationCard>
  );
};
